import { enqueueSnackbar } from "notistack";
import { decodeTokenService } from "../../../services/decodeTokenService";
import { postRegisterSeller } from "../../../services/payment/payment";

export const handleConnect = (id: string) => {
  const email = decodeTokenService.getEmailFromToken() || "";
  postRegisterSeller(id, email)
    .then((res) => {
      window.location.href = res.config.onboarding_url;
    })
    .catch((err) => {
      enqueueSnackbar(
        "An error ocurred while connecting the payment method. Please try again.",
        { variant: "error" }
      );
    });
};

export const handleUpdate = (id: string) => {
  alert(`Actualizando el método de pago con id ${id}`);
};

